import './ShowMore.scss';
import React, { useState } from 'react';

const ShowMore = ({ children, className }) => {
    const [isShow, setIsShow] = useState(false);
    const state = isShow ? 'show' : 'hide';

    return (
        <div className={`showmore ${className} ${state}`}>
            {children}
            <a href="javascript:;" className="link ff-inter text-bright-red ws-nowrap ml-100" onClick={() => setIsShow(!isShow)}>
                {isShow ? 'show less' : 'show more'}                
            </a>        
        </div>
    );
}

export default ShowMore;